import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { observable } from 'mobx'
import type { JobStatus } from '@/features/jobs/job-status'
import { type ProgressionStepStatus } from '@/features/jobs/taxes/progression/JobProgression'
import type { JobScopeChangeStatus } from '@/features/jobs/job-scope-changes/JobScopeChange'
import type { ConsultationStatus } from '@/features/jobs/consultations/Consultation'
import type { TimeRange } from '@/infra/time-range'

export type JobWidgetProps = ModelProps<JobWidget>

export class JobWidget extends Model<JobWidget> {
  static readonly none = new JobWidget()

  id = Id.none
  @observable accessor workspaceId = Id.none
  @observable accessor name = ''
  @observable accessor status: JobStatus = 'Unknown'
  @observable accessor total = 0
  @observable accessor intakeCompleted = false
  @observable accessor progressionStep: ProgressionStepStatus = 'NotStarted'
  @observable accessor scopeChangeStatus: JobScopeChangeStatus = 'Unspecified'
  @observable accessor consultationStatus: ConsultationStatus = 'Unknown'
  @observable accessor consultationBookedTime: TimeRange | undefined = undefined

  // consultationStatus: ConsultationStatus,
  // bookedTime: TimeRange | undefined,
}
